// extracted by mini-css-extract-plugin
export default {"landingPage":"Landing_landingPage__1RF8M","main":"Landing_main__HHS-q","section":"Landing_section__iBfBF","sectionVisible":"Landing_sectionVisible__lcfUy"};